export function buildEndSessionUrl(): string {
  const { REACT_APP_IAM_PUBLIC_URL: authHost = '' } = window._env_

  return `${authHost.replace(/\/$/, '')}/v1/auth/end-session`
}

function trimTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '')
}

function appendHiddenInput(
  form: HTMLFormElement,
  name: string,
  value: string,
): void {
  const input = document.createElement('input')

  input.type = 'hidden'
  input.name = name
  input.value = value
  form.appendChild(input)
}

function submitIamEndSessionForm(
  clientId: string,
  postLogoutRedirectUri: string,
): void {
  const form = document.createElement('form')

  form.method = 'POST'
  form.action = buildEndSessionUrl()
  appendHiddenInput(form, 'client_id', clientId)
  appendHiddenInput(form, 'post_logout_redirect_uri', postLogoutRedirectUri)
  document.body.appendChild(form)
  form.submit()
}

export function redirectToEndSession(): void {
  const {
    REACT_APP_IAM_CLIENT_ID: clientId = '',
    REACT_APP_IAM_REDIRECT_URL: postLogoutRedirectUri = '',
    REACT_APP_API_URL: bffOrigin = '',
  } = window._env_

  const gatewayOrigin = trimTrailingSlash(bffOrigin.trim())

  if (gatewayOrigin) {
    const params = new URLSearchParams({
      client_id: clientId,
      post_logout_redirect_uri: postLogoutRedirectUri,
    })

    window.location.assign(
      `${gatewayOrigin}/v1/auth/clear-session?${params.toString()}`,
    )

    return
  }

  submitIamEndSessionForm(clientId, postLogoutRedirectUri)
}
